import React from 'react'
import HowStartpageWorks from '../how-startpage-works'

const HowStartpageWorksFr = () => {
    return <HowStartpageWorks languageCode="fr" />
}

export default HowStartpageWorksFr
